import localStorageUtil from '@/common/utils/localStorageUtil';
import { Tooltip, withStyles } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import './OverFlowTooltip.css';

export default function OverFlowTooltipWithTabsMui(props) {
    const textElementRef = useRef();
    const isMounted = useRef(true);

    const projectInUseId = localStorageUtil.getSelectedProjectId();
    const [hoverStatus, setHover] = useState(false);

    const compareSize = () => {
        if (textElementRef.current) {
            const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
            if (isMounted.current) {
                setHover(compare);
            }
        }
    };

    useEffect(() => {
        isMounted.current = true;
        compareSize();
        window.addEventListener('resize', compareSize);
        return () => {
            isMounted.current = false;
            window.removeEventListener('resize', compareSize);
        };
    }, [projectInUseId, props.value]);

    const CustomTooltip = props.isCustomMaxWidth
        ? withStyles({ tooltip: { maxWidth: `${props.isCustomMaxWidth}px` } })(Tooltip)
        : Tooltip;

    return (
        <CustomTooltip
            title={props.value}
            disableHoverListener={!hoverStatus}
            placement="top"
            arrow
        >
            <p
                key={props.key || ''}
                onClick={props.onClick}
                ref={textElementRef}
                className={`${props.className || ''} overFlow-lineHeight`}
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textDecoration: props.tab?.isTicketDeleted ? 'line-through' : ''
                }}
            >
                {props.avatar && (<span className='knowledge-item' style={{marginRight: "10px"}}><img src={props.avatar} alt="" style={{width: "24px", height: "24px", maxWidth: "24px", maxHeight: "24px", borderRadius: "50%"}} /></span>)}
                {props.value}
            </p>
        </CustomTooltip>
    );
}

OverFlowTooltipWithTabsMui.defaultProps = {
    value: ''
};
